import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUpDown32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCaretUpDown32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.636 12.293a1 1 0 1 0 1.414 1.414L16 8.757l4.95 4.95a1 1 0 1 0 1.414-1.414l-5.657-5.657L16 5.93l-.707.707zm12.728 7.414a1 1 0 0 0-1.414-1.414L16 23.243l-4.95-4.95a1 1 0 0 0-1.414 1.414l5.657 5.657.707.707.707-.707z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUpDown32);
